/**
 * <s-returns-journey> — returns page "the journey of the box".
 * As each step card ([data-step-card="1".."4"]) reaches the middle of the screen, the host gets data-step="n";
 * config/styles.css moves the Velle box through the story (request → label → shipping → refund).
 * Reduced motion: states still change, but config/styles.css drops every transition and the idle float.
 */
class SReturnsJourney extends HTMLElement {
  #observer;

  connectedCallback() {
    const cards = this.querySelectorAll('[data-step-card]');
    if (!cards.length) return;
    this.dataset.step = this.dataset.step || '1';
    this.#observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        const step = entry.target.dataset.stepCard;
        this.dataset.step = step;
        for (const card of cards) {
          if (card.dataset.stepCard === step) card.setAttribute('aria-current', 'step');
          else card.removeAttribute('aria-current');
        }
      }
    }, { rootMargin: '-45% 0px -45% 0px' });
    cards.forEach((card) => this.#observer.observe(card));
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }
}

customElements.define('s-returns-journey', SReturnsJourney);
